import React from 'react';
import Slider from 'react-slick';
import config from '../../config';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

const SlideShow = ({ slideShowId, className }) => {
    const slideShow = useSelector((state) => state.slideState.slideShows[slideShowId]);

    const settings = {
        dots: false,
        autoplay: true,
        swipeToSlide: true,
        autoplaySpeed: 8000,
        arrows: false
    };

    const renderSlide = (slide) => {
        return (
            <div key={slide.id} className="slide">
                <img className="slide-img" src={config.server + slide.imagePath} alt=''/>
            </div>
        );
    };
    const slideComponents = slideShow && slideShow.slides.map((s) => renderSlide(s));

    return (
        <div className={`temp-slide ${className || ''}`}>
            <Slider {...settings}>
                {slideComponents}
            </Slider>
        </div>
    );
};

SlideShow.propTypes = {
    slideShowId: PropTypes.number.isRequired,
    className: PropTypes.string,
};

export default SlideShow;